import { ScrollReveal } from './ScrollReveal';
import { Check } from 'lucide-react';
import { useLang } from '@/lib/translations';

export default function AurocleDifference() {
  const { t } = useLang();
  const d = t.difference;
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="aurocle-difference-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <ScrollReveal>
              <div className="overline mb-4">{d.overline}</div>
              <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-aurocle-text mb-6">{d.title}</h2>
              <p className="text-base text-aurocle-platinum-muted mb-10 leading-relaxed">{d.sub}</p>
            </ScrollReveal>
            <div className="space-y-3">
              {d.items.map((item, i) => (
                <ScrollReveal key={i} delay={i * 50}>
                  <div className="flex items-center gap-3 group">
                    <div className="w-5 h-5 flex items-center justify-center border border-aurocle-gold/20 group-hover:border-aurocle-gold/50 transition-colors shrink-0">
                      <Check size={10} className="text-aurocle-gold" />
                    </div>
                    <span className="text-sm text-aurocle-text">{item}</span>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
          <ScrollReveal delay={200}>
            <div className="relative">
              <div className="absolute -top-12 -right-12 w-64 h-64 bg-aurocle-gold/8 rounded-full blur-[100px] pointer-events-none" />
              <div className="glass-card p-10 border-aurocle-gold/10">
                <div className="text-xs font-mono uppercase tracking-wider text-aurocle-gold/60 mb-6">{d.builtForLabel}</div>
                <div className="space-y-4">
                  {d.builtFor.map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <div className="w-1 h-1 bg-aurocle-gold rounded-full mt-2 shrink-0" />
                      <span className="text-sm text-aurocle-text leading-relaxed">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
